import { render } from "./ServiciosProgramadosDetalle.vue?vue&type=template&id=698c99e2&ts=true"
import script from "./ServiciosProgramadosDetalle.vue?vue&type=script&lang=ts"
export * from "./ServiciosProgramadosDetalle.vue?vue&type=script&lang=ts"

import "./ServiciosProgramadosDetalle.vue?vue&type=style&index=0&id=698c99e2&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__